import React, { useState, useRef } from 'react';
import { observer } from 'mobx-react-lite';
import { IStatus } from 'interfaces/review/IReviewDataRow';
import { useOnClickOutside } from 'hooks/useOnClickOutside';
import { SelectList } from 'components/ui/SelectList/SelectList';
import { ReactComponent as DownIcon } from '../../../../../components/icons/down.svg';
import { Error, ExpandIconWrapper, Indicator, Line, LiveOrWarmup, StatusCellWrapper } from './StatusCellStyles';

export interface IProps {
  style: any;
  cellContent: IStatus;
  isWarmup: boolean;
  convertPitchCallback: () => void;
  isHidden: boolean;
}
export const StatusCell: React.FC<IProps> = observer((props: IProps) => {
  const { style, cellContent, isWarmup, convertPitchCallback, isHidden } = props;
  const [isErrorListVisible, setIsErrorListVisible] = useState<boolean>(false);
  const [isListBelowBottom, setIsListBelowBottom] = useState<boolean>(false);
  const iconRef = useRef<any>();
  useOnClickOutside(
    iconRef,
    () => {
      setIsErrorListVisible(false);
    },
    'click'
  );

  const handleOnClick = () => {
    setIsErrorListVisible(!isErrorListVisible);
  };

  const getIndicatorClass = () => {
    if (isWarmup) {
      return 'warmup';
    }
    return cellContent.errors.length > 0 ? 'error' : '';
  };

  const getCaption = () => {
    if (isWarmup) {
      return 'Warmup';
    }
    if (cellContent.errors.length > 0) {
      return `${cellContent.errors.length} Error${cellContent.errors.length > 1 ? 's' : ''}`;
    }
    return 'OK';
  };

  return (
    <StatusCellWrapper className={`${isHidden ? 'hidden' : ''}`} style={{ width: 173, ...style }}>
      <Indicator className={`${getIndicatorClass()}`} />
      <div>{getCaption()}</div>
      <ExpandIconWrapper className={`expand-icon${isErrorListVisible ? ' expanded' : ''}`}>
        <DownIcon ref={iconRef} onClick={handleOnClick} />
      </ExpandIconWrapper>
      <SelectList
        visible={isErrorListVisible}
        isBelowBottomCallback={(isBelow: boolean) => setIsListBelowBottom(isBelow)}
        top={isListBelowBottom ? 'auto' : '50px'}
        bottom={isListBelowBottom ? '50px' : 'auto'}
      >
        {cellContent.errors.map((error, index) => {
          return <Error key={index}>{error.errorMessage}</Error>;
        })}
        <Line />
        <LiveOrWarmup onClick={convertPitchCallback}>convert to {isWarmup ? 'live' : 'warmup'}</LiveOrWarmup>
      </SelectList>
    </StatusCellWrapper>
  );
});
